export default "__VITE_ASSET__1263d6da__"